import { ServiceHelper } from "../../Everou/_services/ServiceHelper";
import { PMS_API_URLS } from "../_constants/PMS_API_URLS";

export const PMSAvantioService = {
    listAccommodations,
}

function listAccommodations(uid: string) {
    return ServiceHelper.getRequest(
        PMS_API_URLS.AVANTIO_ACCOMMODATIONS,
        {
            uid: uid,
        }
    );
}
